import Button from '@mui/material/Button';
import PhoneIcon from '@mui/icons-material/Phone';

export default function CallButton({ label = "Call Now", fullWidth = false, phoneNumber }) {
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      href={`tel:${phoneNumber}`}
      startIcon={<PhoneIcon />}
      fullWidth={fullWidth}
    >
      {label}
    </Button>
  );
}
